import {classNames, layout, PushButton} from "@variocube/cube-ui";
import * as React from "react";
import {useLocalization} from "../../i18n";
import {ReactNode} from "react";

interface WizardButtonBar {
    className?: string;
    onCancel: () => any;
    onNext: () => any;
    enableNext: boolean;
    info?: ReactNode;
    cancelTitle?: string;
    nextTitle?: string;
}

export function WizardButtonBar({className, onCancel, onNext, enableNext, info, cancelTitle, nextTitle}: WizardButtonBar) {
    const {t} = useLocalization();
    return (
        <div className={classNames(layout.horizontal, layout.spaceBetween, className)}>
            <PushButton onClick={onCancel}>
                {cancelTitle ?? t("Cancel")}
            </PushButton>
            {info && (
                <div className={classNames(layout.fill, layout.horizontal, layout.end, layout.alignCenter)}>
                    {info}
                </div>
            )}
            <PushButton primary onClick={onNext} disabled={!enableNext}>
                {nextTitle ?? t("Next")}
            </PushButton>
        </div>
    )
}
